import { Pipe, PipeTransform, Injectable } from '@angular/core';
import { CategoryOpenSearch } from '../enums/category-open-search';

@Pipe({
  name: 'categoryIcon',
  pure: true,
})
@Injectable({ providedIn: 'root' })
export class CategoryIconPipe implements PipeTransform {
  transform(id: CategoryOpenSearch): string {
    switch (id) {
       case CategoryOpenSearch.ALL:
        return 'dashboard';
      case CategoryOpenSearch.HEALTH:
        return 'widgets';
      case CategoryOpenSearch.MIGRATION:
        return ' account_balance';
      case CategoryOpenSearch.EDUCATION:
        return 'menu_book';
      case CategoryOpenSearch.LESSONS:
        return 'folder_special';
        case CategoryOpenSearch.EFFECTIVENESS:
        return 'stars';
        case CategoryOpenSearch.RISK:
        return 'report';
      default:
        return 'dashboard';
    }
  }
}
